import { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
const underlineStyles = css `
  background-position: 100% 100%;
  background-size: 100% ${pxToRem(1)};
`;
const commonStyles = css `
  background-image: linear-gradient(currentColor 0 0);
  background-position: 0 100%;
  background-size: 0% ${pxToRem(1)};
  background-repeat: no-repeat;
  transition:
    color 0.25s,
    outline 0.25s,
    background-size 0.25s,
    background-position 0s 0.25s;
  transition-timing-function: ease;
  outline-color: transparent;

  &:hover,
  &:focus-visible,
  &:active {
    ${underlineStyles};
    background-image: linear-gradient(currentColor 0 0);
  }

  &:focus-visible {
    outline: ${pxToRem(4)} solid;
    border-radius: ${themeGet('borderRadius.sm')};
  }
`;
const primaryStyles = css `
  color: ${themeGet('colors.secondary.500')};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${themeGet('colors.secondary.100')} 0 0);

      &:focus-visible {
        color: ${themeGet('colors.secondary.700')};
      }
    `}

  &:hover {
    color: ${themeGet('colors.secondary.500')};
  }

  &:focus-visible {
    color: ${themeGet('colors.secondary.500')};
    outline-color: ${themeGet('colors.focus.secondary')};
    background-image: linear-gradient(${themeGet('colors.secondary.100')} 0 0);
  }

  &:active {
    color: ${themeGet('colors.secondary.700')};
  }
`;
const text200Styles = css `
  color: ${themeGet('colors.text.200')};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${themeGet('colors.border.100')} 0 0);
    `}

  &:hover {
    color: ${themeGet('colors.text.200')};
  }

  &:focus-visible {
    color: ${themeGet('colors.text.200')};
    outline-color: ${themeGet('colors.focus.primary')};
    background-image: linear-gradient(transparent 0 0);
  }

  &:active {
    color: ${themeGet('colors.gray.1000')};
  }
`;
const text300Styles = css `
  color: ${themeGet('colors.text.300')};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${themeGet('colors.border.100')} 0 0);
    `}

  &:hover {
    color: ${themeGet('colors.text.300')};
  }

  &:focus-visible {
    color: ${themeGet('colors.text.300')};
    outline-color: ${themeGet('colors.focus.primary')};
    background-image: linear-gradient(transparent 0 0);
  }

  &:active {
    color: ${themeGet('colors.gray.800')};
    background-image: linear-gradient(${themeGet('colors.gray.700')} 0 0);
  }
`;
export function linkAppearance(appearance) {
    switch (appearance) {
        case 'text-200':
            return text200Styles;
        case 'text-300':
            return text300Styles;
        case 'primary':
        default:
            return primaryStyles;
    }
}
